export default "__VITE_PUBLIC_ASSET__3a13b84f__"